import { render, staticRenderFns } from "./TaskAttachModal.vue?vue&type=template&id=62443626"
import script from "./TaskAttachModal.vue?vue&type=script&lang=js"
export * from "./TaskAttachModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports